import script from "./LoginScreen.vue?vue&type=script&setup=true&lang=js"
export * from "./LoginScreen.vue?vue&type=script&setup=true&lang=js"

import "./LoginScreen.vue?vue&type=style&index=0&id=255e17cc&scoped=true&lang=css"

import exportComponent from "/home/adelaplace/PycharmProjects/smartcast/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-255e17cc"]])

export default __exports__